// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export default css`
  .storeinfo {
    ${(props) =>
      props.isStoreDetailsRedesignMobileEnabled &&
      `
    margin: 0 ${props.theme.spacing.ELEM_SPACING.REG};
    margin-top: ${props.theme.spacing.APP_LAYOUT_SPACING.XS};
    `}
  }
  .store-name.store-name--details {
    text-transform: capitalize;
    font-family: ${(props) =>
      props.isStoreDetailsRedesignMobileEnabled
        ? props.theme.fonts.secondaryFontFamily
        : props.theme.brandSpecificStyles.JOIN_OUR_TEXT_ALERTS_FONT};
    ${(props) =>
      props.isStoreDetailsRedesignMobileEnabled &&
      ` margin-bottom: ${props.theme.spacing.ELEM_SPACING.SM};
        color: ${props.theme.colors.TEXT.DARK};
        font-weight: ${props.theme.fonts.fontWeight.bold};
        font-size: ${props.theme.fonts.fontSize.body.bodytext.copy6}px;
        `}
  }

  &__backlink {
    margin-left: 13px;
  }
  .back-anchor {
    margin-left: 13px;
  }
  .address-meta {
    align-items: flex-start;
  }

  .store-hrs-mobileview {
    margin: 0;
    width: 100%;
  }

  .storeaddressinfo__btn {
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 210px;
      margin-left: ${(props) =>
        props.isStoreDetailsDesktopRedesignEnabled && props.theme.spacing.ELEM_SPACING.SM};
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: 188px;
    }
  }
  .seo-data-tab-view {
    display: none;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      display: block;
    }
  }
  .seo-data-tab-view .title,
  .seo-data-dsk-view .title {
    text-align: left;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy6}px;
  }

  .seo-data-dsk-view {
    display: none;
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      display: block;
    }
    @media ${(props) =>
        `(min-width:${props.theme.breakpoints.mediumMax}) and (max-width: ${props.theme.breakpoints.largeMax})`} {
      display: block;
    }
  }

  .seo-data-dsk-view .seo-text {
    padding: 0;
  }

  .google-map-wrapper {
    margin-left: auto;
    margin-right: auto;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    padding: ${(props) => `0 ${props.theme.spacing.ELEM_SPACING.REG}`};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0;
    }
  }

  .store-hrs-wrapper {
    width: 100%;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    justify-content: flex-start;
  }
  .store-hrs-wrapper > div {
    width: 33%;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .aspect-ratio-box {
    height: 0;
    overflow: hidden;
    position: relative;
    padding-top: 350px;
  }
  .aspect-ratio-box-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .storeSpecialBannerWrapper {
    margin-right: 0;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-bottom: 32px;
    }
  }
`;

export const StoreDetailWrapper = styled.div`
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    ${(props) => props.desktop && 'display: none;'}
    ${(props) => props.mobile && 'display: block;'}
  }
  ${(props) => props.mobile && 'display: none;'}
`;
